<template>
	<div>
		<el-row>
			<el-col :span="2">
				<div>
				<el-button round type="primary" style="font-size: 20px;" @click="baonewAdd">新</br>增</br>加</br>项</br>包</el-button>
			</div>
			</el-col>
		
		<el-col :span="22">
			
		<el-table border ref="multipleTable" @row-click="SelectedChange" tooltip-effect="dark" :data="OrderGroupAddList">
			<el-table-column prop="GroupAddName" label="加项包名称" width="160px"></el-table-column>
			<el-table-column prop="CanSelAll" label="可随意选项">
				<template slot-scope="scope">
					<label v-if="scope.row.CanSelAll=='1'">是</label>
					<label v-if="scope.row.CanSelAll=='0'">否</label>
				</template>
			</el-table-column>
			<el-table-column prop="MaxNum" label="最多可选几项"></el-table-column>
			<el-table-column prop="Memo" label="备注"></el-table-column>
			<el-table-column label="操作" width="200px" fixed="right">
				<template slot-scope="scope">
					<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
					<el-button @click="handleDelete(scope.$index, scope.row)" icon="el-icon-circle-close" type="text" size="small">删除</el-button>

				</template>
			</el-table-column>
		</el-table>
		
		</el-col>
		</el-row>
		<!-- 修改信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="加项包名称">
					<el-input v-model="EditInfo.GroupAddName"></el-input>
				</el-form-item>
				<el-form-item label="最多可选几项">
					<el-input type='number' v-model="EditInfo.MaxNum"></el-input>
					可随意选项<el-switch v-model="EditInfo.CanSelAll" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="EditInfo.Memo"></el-input>
				</el-form-item>

				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

		<!-- ----新增信息---- -->
		<el-dialog title="新增信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<el-form-item label="加项包名称">
					<el-input v-model="AddInfo.GroupAddName"></el-input>
				</el-form-item>
				<el-form-item label="最多可选几项">
					<el-input type='number' v-model="AddInfo.MaxNum"></el-input>
					可随意选项<el-switch v-model="AddInfo.CanSelAll" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="AddInfo.Memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<ul style="float: left;text-align: left;width: 50%;">
			<el-card>
				<div slot="header" style="text-align: left;">
					<span><b>已选项目</b>{{SelTotal}}</span>
				</div>
				<el-card>
					<el-row>
							<el-button plain type="warning" @click="btnDiscount">按折扣调价</el-button>
							<el-input style="width: 70px;" type="number" placeholder="折扣" v-model="avgdiscount"></el-input>
							<el-button plain type="warning" @click="btnAvg">按总价平摊</el-button>
							<el-input style="width: 160px;" type="number" placeholder="请输入平摊金额" v-model="avgcash">
							</el-input>
					
						</el-row>
						<li>
							<el-button round type="primary" @click="btnOK">保存加项包项目</el-button>
						</li>
					</el-card>
					<el-card>

				<el-table max-height="480px" border @row-dblclick="SelItemdbclick" tooltip-effect="dark" :data="SelSaleModuleList">
					<el-table-column prop="SaleModuleName" label="项目名称" width="200px"></el-table-column>
					<el-table-column prop="OrgPrice" label="原价" width="100px"></el-table-column>
					<el-table-column prop="Discount" label="折扣" width="100px"></el-table-column>
					<el-table-column prop="CurPrice" label="售价" width="100px"></el-table-column>
				</el-table>
			</el-card>
			</el-card>
			
		</ul>
		<ul style="float: left;text-align: left;width: 50%;">
			<el-card>
				<div slot="header" style="text-align: left;">
					<span><b>系统项目</b></span>
				</div>
					<li>
						<el-input type="text" v-model="txtFind" placeholder="项目名称拼音首字母查找" @input="FindTextChange()">
						</el-input>
					</li>
				
					<el-card>
						<el-table max-height="500px" border ref="multipleTable" @row-dblclick="SysItemdbclick" tooltip-effect="dark" :data="SaleModuleListShow.slice((currentPage-1)*pagesize,currentPage*pagesize)">
							<el-table-column prop="SaleModuleName" label="项目名称" width="200px"></el-table-column>
							<el-table-column prop="OrgPrice" label="原价" width="100px"></el-table-column>
							<el-table-column prop="MiniDiscount" label="最低折扣" width="120px"></el-table-column>
						</el-table>
						<el-footer style="margin-top:20px;">
							<template>
								<div class="block">
									<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
									 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, next, jumper" :total="SaleModuleListShow.length"></el-pagination>
								</div>
							</template>
						</el-footer>
					</el-card>
					</el-card>
		</ul>

	</div>


</template>

<script>
	import groupitem from '../../apifunction/GroupItem.js'
	import groupadditem from '../../apifunction/GroupAddItem.js'
	import py from '../../commontools/chineseToPinYin.js'
	export default {
		created() {
			this.initData();

		},
		watch: {
			// "$route": "initData"
			'groupEnt.GroupID': function(val, oldval) {
				{
					//this.avgcash = this.groupEnt.GroupPrice;
					//this.InitSalerModuls();
					this.InitOrderGroupItems();
					this.InitOrderGroupAdds();
				}
			}
		},
		data() {
			return {
				currentPage: 1,
				pagesize: 10,
				userent: this.$myglobal.getUserInfo(),
				groupEnt: this.inordergroup,
				avgcash: 0,
				avgdiscount: 1,
				SelTotal: '',
				txtFind: '',
				SelSaleModuleList: [],
				SaleModuleListAll: [],
				SaleModuleListShow: [],
				SaleItemAll: [],
				OrderGroupItems: [],
				OrderGroupAddList: [],
				CurGroupAddID: '',
				bao1edit: false,
				bao1newadd: false,
				idx: null,
				EditInfo: {
					OrderID: '',
					GroupID: '',
					GroupAddID: '',
					GroupAddName: '',
					MaxNum: 0,
					CanSelAll: '0',
					Memo: ''
				},
				AddInfo: {
					OrderID: '',
					GroupID: '',
					GroupAddID: '',
					GroupAddName: '',
					MaxNum: 0,
					CanSelAll: '0',
					Memo: ''
				}

			}
		},
		props: ['inordergroup'],
		mounted() {

		},
		methods: {
			initData() {
				// alert(1)
				// this.avgcash = this.groupEnt.GroupPrice;
				this.InitAllSaleModule();
				this.InitSaleItemAll();
				this.InitOrderGroupItems();
				this.InitOrderGroupAdds();
			},
			InitOrderGroupItems() {
				groupitem.GetGroupItemDataByGroup(this.groupEnt.OrderID, this.groupEnt.GroupID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							this.OrderGroupItems = JSON.parse(ent.Data);

						}
					})
			},
			InitOrderGroupAdds() {
				groupadditem.GetGroupAddByGroup(this.groupEnt.OrderID, this.groupEnt.GroupID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							this.OrderGroupAddList = JSON.parse(ent.Data);

						}
					})
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;

				this.EditInfo = {
					OrderID: row.OrderID,
					GroupID: row.GroupID,
					GroupAddID: row.GroupAddID,
					GroupAddName: row.GroupAddName,
					MaxNum: row.MaxNum,
					CanSelAll: row.CanSelAll,
					Memo: row.Memo
				};
			},
			SelectedChange(row, col, event) {
				this.CurGroupAddID = row.GroupAddID;
				this.GetSelSaleModules(row);
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {

				groupadditem.EditGroupAdd(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.OrderGroupAddList.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.OrderID = '';
				this.AddInfo.GroupID = '';
				this.AddInfo.GroupAddID = '';
				this.AddInfo.GroupAddName = '';
				this.AddInfo.MaxNum = 0;
				this.AddInfo.CanSelAll = '0';
				this.AddInfo.Memo = '';
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if (this.AddInfo.GroupAddName == '') {
					this.$message.success("加项包名称不能为空！");
					return;
				}
				let user = this.$myglobal.getUserInfo();
				this.AddInfo.OrderID = this.groupEnt.OrderID;
				this.AddInfo.GroupID = this.groupEnt.GroupID;
				this.AddInfo.GroupAddID = this.CommonFun.NewGuid();
				groupadditem.AddGroupAdd(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.OrderGroupAddList.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			},
			handleDelete(index, row) {
				this.$confirm('确定要删掉此加项包吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {
					groupadditem.DelGroupAdd(row.OrderID, row.GroupID, row.GroupAddID)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.OrderGroupAddList.splice(index, 1)
								//this.bao1detele = false;
								this.$message.warning("删除成功");

							} else {
								this.$message.info(ent.Msg);
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},

			btnAvg: function() {
				groupitem.ChangeItemPrice(this.SelSaleModuleList, this.avgcash, '', this.SaleItemAll)
				this.ShowSelTotal();
			},
			btnDiscount: function() {
				groupitem.ChangeItemPrice(this.SelSaleModuleList, '', this.avgdiscount, this.SaleItemAll)
				this.ShowSelTotal();
			},
			FindTextChange: function() {
				if (this.txtFind == '') {
					this.SaleModuleListShow = JSON.parse(JSON.stringify(this.SaleModuleListAll));
					return;
				}
				//alert(py.chinesesToPY(this.SaleModuleListAll[0].SaleModuleName))
				var templist = this.SaleModuleListAll.filter(item => {
					if (item.py.toLowerCase().indexOf(this.txtFind.toLowerCase()) > -1) {
						//if (item.SaleModuleName.indexOf(this.txtFind) > -1) {
						return item
					}
				});
				this.SaleModuleListShow = JSON.parse(JSON.stringify(templist));
			},
			InitSaleItemAll: function() {
				groupitem.GetSaleItemAll(this.userent.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							this.SaleItemAll = JSON.parse(ent.Data);

						}
					})
			},
			InitAllSaleModule: function() {
				groupitem.GetSaleModuleValid(this.userent.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {

							this.SaleModuleListAll = JSON.parse(ent.Data);
							for (let i = 0; i < this.SaleModuleListAll.length; i++) {
								this.SaleModuleListAll[i].py = py.chinesesToPY(this.SaleModuleListAll[i].SaleModuleName)
							}
							this.SaleModuleListShow = JSON.parse(ent.Data);

						}
					})
			},
			GetSelSaleModules: function(row) {
				groupadditem.GetGroupAddItemByID(row.GroupAddID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							this.SelSaleModuleList = [];
							if (ent.Data != 'null') {
								var list = JSON.parse(ent.Data);
								for (let i = 0; i < list.length; i++) {
									var item = this.GetSelSaleModule(list[i]);
									this.SelSaleModuleList.push(list[i])
								}
							}
							this.ShowSelTotal();
						}
					})
			},
			ShowSelTotal: function() {
				if (this.SelSaleModuleList == null || this.SelSaleModuleList.length < 1)
					this.SelTotal = '【无项目】';
				else {
					let sum = 0;
					let salesum = 0;
					for (let i = 0; i < this.SelSaleModuleList.length; i++) {
						var li = this.SelSaleModuleList[i];
						sum += parseFloat(li.OrgPrice);
						salesum += parseFloat(li.CurPrice);
					}
					this.SelTotal = '【总计：原价' + parseFloat(sum).toFixed(1) + ';售价' + parseFloat(salesum).toFixed(1) + ';折扣' + parseFloat(
						salesum / sum).toFixed(4) + '】';
				}
			},
			SysItemdbclick(item, event) {
				var ent = this.GetSelSaleModule(item);
				let obj = this.SelSaleModuleList.find(v => v.SaleModuleID === ent.SaleModuleID);
				if (obj) {
					this.$message.info('项目已存在！')
				} else {
					if (item.AdaptSex != '3' && this.groupEnt.Sex != '3' && item.AdaptSex != this.groupEnt.Sex) {
						this.$message.info('选项与‘分组适用性别’不符！');
						return;
					}
					var msg = groupitem.CheckRepeatItem(ent, this.OrderGroupItems, this.SaleItemAll)
					if (msg != '') {
						this.$message.info('分组项目中:' + msg);
						return;
					}
					msg = groupitem.CheckRepeatItem(ent, this.SelSaleModuleList, this.SaleItemAll)
					if (msg == '') {
						//alert(JSON.stringify(ent))
						this.SelSaleModuleList.push(ent)
						this.ShowSelTotal();
					} else
						this.$message.info('加项包项目中:' + msg);
				}
			},
			SelItemdbclick: function(item, event) {
				let index = this.SelSaleModuleList.findIndex(f => f.SaleModuleID == item.SaleModuleID);
				this.SelSaleModuleList.splice(index, 1)
				this.ShowSelTotal();
			},
			GetSelSaleModule: function(ent) {
				return {
					SaleModuleID: ent.SaleModuleID,
					SaleModuleName: ent.SaleModuleName,
					OrgPrice: ent.OrgPrice,
					Discount: ent.Discount,
					CurPrice: ent.CurPrice,
					MiniDiscount: 0

				}
			},
			btnOK: function() {
				if (this.CurGroupAddID == '') {
					this.$message.info('请选择加项包！');
					return;
				}
				if (this.SelSaleModuleList.length < 1) {
					this.$message.info('请选择加项包项目！');
					return;
				}
				// alert(JSON.stringify(this.groupEnt))
				groupadditem.SaveGroupAddItem(this.CurGroupAddID, this.SelSaleModuleList)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('保存成功！');

						} else
							this.$message.info(ent.Msg);
					})

			}
		}

	}
</script>
